<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Christian Dogmatics: An Introduction</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="OT" id="pre001"><a id="page_vii"></a><a href="#/xhtml/contents#pre-001">Preface to the English Edition</a></p>
<p class="Bodyflush">We are greatly indebted to Reinder Bruinsma, who is an experienced translator of Dutch theological literature into English, for providing a very reliable and smooth translation of this voluminous work in a relatively short time. Our American colleague Jim Bratt (Calvin College, Grand Rapids, MI), has carefully checked the flow of the English, pointed out possible sources of misunderstanding for an Anglo-Saxon audience, and proposed quite a few improvements, in both style and content. We are greatly in his debt. We also thank our former student-assistant Ruben van den Belt for providing us with references to English versions of sources we originally quoted in Dutch or German.</p>
<p class="Body">Since we realized that it would not make much sense to quote sources that are available only in Dutch, we substantially reduced the number of references to Dutch sources. Yet, we intentionally did not go to great lengths to remove every trace of the Dutch context within which this volume originally took shape. Especially in the case of twentieth-century Dutch theologians who have been (and in many cases still are) very influential in the Netherlands and beyond (e.g., in South Africa), and because of the scope, originality, creativity, and quality of their theological work, we decided to leave instructive references to their work unaltered, even though for now it may be available only in Dutch. Here we are thinking especially of the work of twentieth-century theologians like K. H. Miskotte, O. Noordmans, and A. A. van Ruler. It is good for an international audience to see that Dutch theology did not stop with Kuyper and Bavinck, however important the work of these two earlier giants was and still is. Finally, we decided to refer to German sources in English translation, where one was available, but we did <a id="page_viii">not hesitate to quote German sources when there was no Anglophone alternative.</a></p><a id="page_viii">
<p class="RightSb1">C<span class="small">ORNELIS VAN DER</span> K<span class="small">OOI</span> &amp;<br/>G<span class="small">IJSBERT VAN DEN</span> B<span class="small">RINK</span><br/><i>Amsterdam, January 2016</i></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface001.vue?7ef16521